import { render, staticRenderFns } from "./ProductGroupIndex.vue?vue&type=template&id=8c26cb44&scoped=true&"
import script from "./ProductGroupIndex.vue?vue&type=script&lang=js&"
export * from "./ProductGroupIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupIndex.vue?vue&type=style&index=0&id=8c26cb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c26cb44",
  null
  
)

export default component.exports